import { BaseService } from './base.service'

export class EarlyPaymentService extends BaseService {
  static get entity () {
    return 'earlyPayments'
  }

  static get listUrl () {
    return 'EarlyPayment/GetEarlyPayment'
  }

  static get detailUrl () {
    return 'EarlyPayment/GetEarlyPayment'
  }

  static calculateEarlyPaymentAll (contractNo, date) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`EarlyPayment/CalculateEarlyPaymentAll/${contractNo}`, {
        InterestDate: date
      })
        .then(response => {
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static calculateEarlyPaymentPrincipalReduce (contractNo, date, amount, is5050Contract) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`EarlyPayment/CalculatePrincipalReduce/${contractNo}`, {
        InterestDate: date,
        Amount: amount,
        Is5050Contract: is5050Contract
      })
        .then(response => {
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getEarlyPaymentNote (contractNo, isLiquid = false) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('EarlyPayment/EarlyPaymentNote', { params: { contractNo: contractNo, isLiquid: isLiquid } })
        .then(response => {
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getEarlyPaymentGuideline () {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('EarlyPayment/EarlyPaymentGuideline')
        .then(response => {
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }
}
